import React from 'react';
import { Box } from '~ui-kit/components/box/box';
import { Typography } from '~ui-kit/components/typography/typography';

interface QuestionTitleProps {
  text: string;
  helper?: React.ReactNode;
}

export function QuestionTitle({ text, helper }: QuestionTitleProps) {
  return (
    <Box align="center" justify="center" flexDirection="column" width={['100%']}>
      <Typography
        component="h1"
        $fontFamily="Montserrat"
        $fontWeight={400}
        $fontSize={['28px', '32px']}
        $mt={[4]}
        $mb={[2]}
        $mx={[2]}
      >
        {text}
        {helper}
      </Typography>
    </Box>
  );
}
